import type { ReactNode } from "react";

import { Box, Chip } from "@mui/material";

interface RenderChipSelectValueOptions<T> {
  selected: unknown;
  translateFn: (value: T) => string;
  emptyMessage?: string;
}

export function renderChipSelectValue<T extends string | number>({
  selected,
  translateFn,
  emptyMessage,
}: RenderChipSelectValueOptions<T>): ReactNode {
  if (!Array.isArray(selected)) return "";

  if (selected === null || selected === undefined || selected.length === 0) {
    return emptyMessage || "";
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {selected.map((value: T) => (
        <Chip key={value} label={translateFn(value)} size="small" />
      ))}
    </Box>
  );
}
